import React, { useState } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { useTranslation } from 'react-i18next';
import FleetSessionInvoices from './FleetSessionInvoices';
import FleetConsolidatedInvoices from './FleetConsolidatedInvoices';

const FleetInvoices = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('session');

  return (
    <LayoutContainer>
      <AdminHeader title={t('Fleet Invoices')} />
      <div className="page-content-wrapper scrollable">
        <div className="tab-block">
          <div className="tab-nav-block">
            <a
              href="#"
              className={`tab-nav__item ${activeTab === 'session' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab('session');
              }}
            >
              {t('Session Invoices')}
            </a>
            <a
              href="#"
              className={`tab-nav__item ${activeTab === 'consolidated' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                setActiveTab('consolidated');
              }}
            >
              {t('Consolidated Invoices')}
            </a>
          </div>
        </div>
        <div className="countryList-page">
          <Card>
            <div className="countryList-page-wrapper">
              {activeTab === 'session' && <FleetSessionInvoices />}
              {activeTab === 'consolidated' && <FleetConsolidatedInvoices />}
            </div>
          </Card>
        </div>
      </div>
    </LayoutContainer>
  );
};

export default FleetInvoices;
